import React from "react";
import PropTypes from "prop-types";
import {AIcon} from "@cisco-sbg-ui/magna-react";
import {getDispositionDef} from "utils/disposition";
import css from "./DispositionIcon.module.scss";

const DispositionIcon = ({disposition, ...otherProps}) => {
  if (!disposition) return null;

  const {title, color} = getDispositionDef(disposition);

  return (
    <AIcon
      data-testid={"EntityList-DispositionIcon"}
      className={css.dispositionIcon}
      style={{color}}
      {...otherProps}>
      {title.toLowerCase()}
    </AIcon>
  );
};

DispositionIcon.propTypes = {
  disposition: PropTypes.number
};

export default DispositionIcon;
